module.exports = __webpack_public_path__ + "static/spraypaint-29aa14ce3daecf8d5e20e852738d3b76.png";